import { RouteRecordRaw } from 'vue-router';
import { requireAuth, setDayjsTimezone } from '@/common/router/navigationGuard';
import { ROLE_PERMISSION_KEY } from '@/common/define/rolePermission.define';
import { extractAccessibleRoutes } from '@/common/auth/auth.utils';
import { RoleId, Supervisors } from '@/common/auth/auth.defines';
import BaseViewport from '@/common/components/templates/baseViewport/BaseViewport.vue';
import { VIEWPORT_TYPE } from '@/common/components/templates/baseViewport/baseViewport.define';

const PREFIX_ALERT = 'alert_';

const alertMenu: RouteRecordRaw[] = [
  {
    path: '/alert/',
    name: `${PREFIX_ALERT}Alert`,
    component: BaseViewport,
    meta: {
      rolePermission: ROLE_PERMISSION_KEY.MONITORING.MONITORING_ALERT,
      viewport: VIEWPORT_TYPE.REALTIME,
    },
    children: [
      {
        path: 'list',
        name: `${PREFIX_ALERT}Alert List`,
        component: () => import('@/alert/views/alertView/AlertView.vue'),
        beforeEnter: [requireAuth, setDayjsTimezone],
        meta: {
          rolePermission: ROLE_PERMISSION_KEY.MONITORING.MONITORING_ALERT_LIST,
        },
      },
      {
        path: 'event-alert-list',
        name: `${PREFIX_ALERT}Event Alert List`,
        component: () => import('@/alert/views/eventAlertListView/EventAlertListView.vue'),
        beforeEnter: [requireAuth, setDayjsTimezone],
        meta: {
          rolePermission: ROLE_PERMISSION_KEY.MONITORING.MONITORING_ALERT_EVENT_ALERT_LIST,
        },
      },
      {
        path: 'notification-history',
        name: `${PREFIX_ALERT}Notification History`,
        component: () =>
          import('@/alert/views/notificationHistoryView/NotificationHistoryView.vue'),
        beforeEnter: [requireAuth, setDayjsTimezone],
        meta: {
          rolePermission: ROLE_PERMISSION_KEY.MONITORING.MONITORING_ALERT_NOTIFICATION_HISTORY,
          roles: Supervisors,
        },
      },
    ],
  },
];

const getAlertNaviMenu = (roleId: RoleId) => {
  const filteredAlertMenu = extractAccessibleRoutes(alertMenu, roleId);
  return [...filteredAlertMenu];
};

export { alertMenu, getAlertNaviMenu };
